

export const getLocalDateTimeWithTimeZoneFromEpochTime = (tz, ts) => {

    if (!tz || !ts) {
        return ""
    }

    let startTimeStr = ""
    let d = new Date(0)
    d.setUTCSeconds(ts)
    startTimeStr = d.toLocaleDateString("en-US", { timeZone: tz, year: 'numeric', month: 'long', day: 'numeric' })
        + ' ' + d.toLocaleTimeString("en-US", { timeZone: tz, timeZoneName: 'short' })

    return startTimeStr
}

export const getLocalDateEpochTime = (tz, ts) => {

    if (!tz || !ts) {
        return ""
    }

    let startTimeStr = ""
    let d = new Date(0)
    d.setUTCSeconds(ts)
    startTimeStr = d.toLocaleDateString("en-US", { timeZone: tz, year: 'numeric', month: 'long', day: 'numeric' })
    return startTimeStr
}

export const getNowWithTimeZone = (tz, ts) => {

    if (!tz || !ts) {
        return ""
    }

    let startTimeStr = ""
    startTimeStr = ts.toLocaleDateString("en-US", { timeZone: tz, year: 'numeric', month: 'numeric', day: 'numeric' })
        + ' ' + ts.toLocaleTimeString("en-US", { timeZone: tz, timeZoneName: 'short' })

    return startTimeStr
}
